export function humanizeNumber(num: number): string {
  return num.toLocaleString();
}
